<template>
  <div
    v-if="url"
    ref="lottie"
    class="lottier-container"
    v-bind="$attrs"
    @click="handleClick"
  ></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  props: {
    url: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    clickFunc: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      id: Math.random(),
      instance: null,
      uniqueName: null,
    };
  },
  computed: {
    lottie() {
      return this.instance;
    },
  },
  mounted() {
    if (!this.url || !this.name || window.__PRERENDER_INJECTED) {
      return;
    }
    if (this.$refs.lottie) {
      console.log('this.url', this.url);
      console.log('this.name', this.name);
      console.log('this.$refs.lottie', this.$refs.lottie);
      // 使用唯一名称避免冲突
      this.uniqueName = `${this.name}_${this.id}`;
      this.instance = lottie.loadAnimation({
        container: this.$refs.lottie,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        name: this.uniqueName,
        path: this.url,
      });
    }
  },
  destroyed() {
    if (this.instance) {
      // 优先使用实例方法销毁，更安全
      this.instance.destroy();
    } else if (this.uniqueName) {
      // 降级方案：通过全局 name 销毁
      lottie.destroy(this.uniqueName);
    }
  },
  methods: {
    handleClick() {
      if (typeof this.clickFunc === 'function') {
        this.clickFunc();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lottier-container {
  display: flex;
  position: relative;
  overflow: hidden;
}
</style>
